import { render, staticRenderFns } from "./CampaignsPayments.vue?vue&type=template&id=d20c403e"
import script from "./CampaignsPayments.vue?vue&type=script&lang=js"
export * from "./CampaignsPayments.vue?vue&type=script&lang=js"
import style0 from "./CampaignsPayments.vue?vue&type=style&index=0&id=d20c403e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports